import jQuery from 'jquery';
let $ = jQuery;
import gap from 'MOBILE/Gap.js';

import "HSNDIR/Service.js";

/**
    * class HSN.Service.FavoriteService
    *
    * Provides an abstracted interface for favoriting or unfavoriting an object.
    **/
HSN.Service.FavoriteService = function () {
    /**
        * new HSN.Service.FavoriteService()
        **/
    this.debug = false;//print out debugging messages during execution
    this.favoritedClass = 'favorited';
    this.favoriteQueriedClass = 'favorite-queried';
    this.favoriteTooltip = 'Add to Favorites';
    this.unfavoriteTooltip = 'Remove from Favorites';

    if (typeof window.console === "undefined") {
        window.console = {
            log: function () { }
        };
    }
};

/**
* HSN.Service.FavoriteService.OBJECT_TYPE = Object
*
* An enumeration of object types that can be favorited:
* - PRODUCT: A product.
* - BRAND: A brand.
**/
HSN.Service.FavoriteService.OBJECT_TYPE = {
    PRODUCT: 1,
    BRAND: 2
};

HSN.Service.FavoriteService.prototype = {
    /**
        * HSN.Service.FavoriteService#Favorite(objectType, objectId, config) -> void
        * - objectType (HSN.Service.FavoriteService.OBJECT_TYPE): The type of the object being favorited.
        * - objectId (String): The identifier of the object to favorite.
        * - webId (String): The variant of the object to favorite if favoriting product.
        * - config (Object): A configuration object for the call
        *   consisting of the following keys:
        *   - callback (Function): The function to call after the service completes its call. It will recieve a single boolean argument representing the success or failure of the call.
        *   - scope (Object): The scope to execute the callback function in.
        *
        * Favorites the given object with the backend Favorite service and then
        * calls the callback, if given with the success or failure status of the call.
        **/
    Favorite: function (objectType, objectId, webId, config) {
        this._toggleFavorite(objectType, objectId, webId, config);
    },

    /**
        * HSN.Service.FavoriteService#Unfavorite(id, config) -> void
        * HSN.Service.FavoriteService#Unfavorite(objectType, objectId, config) -> void
        * - objectType (HSN.Service.FavoriteService.OBJECT_TYPE): The type of the object being unfavorited.
        * - objectId (String): The identifier of the object to unfavorite.
        * - webId (String): The variant of the object to favorite if favoriting product.
        * - config (Object): A configuration object for the call
        *   consisting of the following keys:
        *   - callback (Function): The function to call after the service completes its call. It will recieve a single boolean argument representing the success or failure of the call.
        *   - scope (Object): The scope to execute the callback function in.
        *
    * Unfavorites the given object with the backend Favorite service and then
        * calls the callback, if given with the success or failure status of the call.
        **/
    Unfavorite: function (objectType, objectId, webId, config) {
        this._toggleFavorite(objectType, objectId, webId, config);
    },



    CheckForFavorites: function (selector) {
        var favoriteLinks = $(selector);
        if (!favoriteLinks.length) {
            return;
        }
        var scope = this;

        if (Modernizr.sessionstorage) {
            if (sessionStorage["hasCheckedFavorites"] !== 'true') {
                sessionStorage["hasCheckedFavorites"] = 'true';
                $.ajax('/account/favorites/all-favorites', {
                    context: this,
                    dataType: 'json',
                    type: 'GET',
                    success: function (data) {
                        if (data) {
                            if (data.FavoriteProducts) {
                                data.FavoriteProducts.forEach(function (favoriteProduct) {
                                    var objectType = HSN.Service.FavoriteService.OBJECT_TYPE.PRODUCT;
                                    var productId = 'fav-' + objectType + '-';
                                    productId += favoriteProduct.ProductId;

                                    sessionStorage[productId] = favoriteProduct.VariantId || 'true';
                                });
                            }

                            if (data.FavoriteBrands) {
                                data.FavoriteBrands.forEach(function (favoriteBrand) {
                                    var objectType = HSN.Service.FavoriteService.OBJECT_TYPE.BRAND;
                                    var brandId = 'fav-' + objectType + '-';
                                    brandId += favoriteBrand;

                                    sessionStorage[brandId] = 'true';
                                });
                            }

                            favoriteLinks.each(function () {
                                scope.UpdateFavoriteLink($(this));
                            });
                        }
                    }
                });
            }
            else {
                favoriteLinks.each(function () {
                    scope.UpdateFavoriteLink($(this));
                });
            }

            var favorites = scope._getAllFavoritesFromStorage();
            $.each(favorites, function () {
                var favorite = this;

                HSN.Instance().Events.Trigger(HSN.Application.EVENT.FAVORITE_INITIALIZED, favorite.objectType, favorite.objectId, favorite.webId);
            });
        }
        else {
            var favoritesList = [];
            favoriteLinks.each(function () {
                var $fav = jQuery(this);
                var objectType = $fav.data('object-type');
                var objectId = $fav.data('object-id');

                var favoriteObject = { objectType: objectType, objectId: objectId };
                var alreadyExist = $.grep(favoritesList, function (favorite) {
                    return (favorite.objectType === objectType) && (favorite.objectId === objectId);
                }).length > 0;

                if (!alreadyExist) {
                    favoritesList.push(favoriteObject);
                }
            });

            $(document).ready(function () {
                var $favoritesList = $(favoritesList);
                var favoritesRequest = $favoritesList.map(function () {
                    return this.objectType + "-" + this.objectId;
                }).toArray();

                $.ajax('/account/favorites/are-items-favorites',
                    {
                        context: this,
                        data: { ids: JSON.stringify(favoritesRequest) },
                        type: 'POST',
                        dataType: 'json',
                        success: function (data) {
                            $favoritesList.each(function (index) {
                                var favorite = this;
                                var value = data.favorites[index];
                                var isFavorited = value > 0;
                                var isVariant = value > 1;
                                var favoriteValue = isVariant ? value : isFavorited ? "true" : null;

                                if (isFavorited) {
                                    favoriteLinks.filter(function () {
                                        return ($(this).data("object-type") === favorite.objectType) && ($(this).data("object-id") === favorite.objectId);
                                    }).each(function () {
                                        scope.UpdateFavoriteLink($(this), favoriteValue);
                                    });

                                    var webId = isVariant ? favoriteValue : null;
                                    HSN.Instance().Events.Trigger(HSN.Application.EVENT.FAVORITE_INITIALIZED, favorite.objectType, favorite.objectId, webId);
                                }
                            });
                        }
                    });
            });
        }
    },

    UpdateFavoriteLink: function ($favoriteLink, favoriteValue) {
        var scope = this;

        if (!$favoriteLink || $favoriteLink.length == 0) {
            return;
        }

        $.each($favoriteLink, function () {
            var isFavoriteProduct;
            var favoriteIsVariant;
            var linkObjectId = $(this).data('object-id');
            var linkObjectType = $(this).data('object-type');
            var linkVariantId = $(this).data('web-id');
            var favoriteId = 'fav-' + linkObjectType + '-' + linkObjectId;
            var favoriteKeyValue;
            var favoritedVariantId;
            var isSaveChangesLink = $(this).hasClass('save-changes');
            var variantSpecificFavorLink = $(this).data('variant-specific-favorite-link');

            if (!favoriteValue) {
                if (Modernizr.sessionstorage) {
                    favoriteKeyValue = sessionStorage.getItem(favoriteId);
                } else { //no browser storage, fallback to link value
                    favoriteKeyValue = scope._getFavoriteValueFromLink($(this));
                }
            } else {
                favoriteKeyValue = favoriteValue;
            }

            favoriteIsVariant = $.isNumeric(favoriteKeyValue); //product has a variant favorited
            favoritedVariantId = favoriteIsVariant ? favoriteKeyValue : null;

            if (variantSpecificFavorLink) {
                isFavoriteProduct = favoriteKeyValue == linkVariantId;//only favorite if webid matches from link to favorited webid
            } else {
                isFavoriteProduct = favoriteKeyValue != null;
            }

            if (isFavoriteProduct) {
                $(this).addClass(scope.favoritedClass).data('tooltip', scope.unfavoriteTooltip);
                $(this).attr('aria-label', scope.unfavoriteTooltip);
                if (favoriteIsVariant) {
                    $(this).data('favorite-web-id', favoritedVariantId);
                    $(this).attr('data-favorite-web-id', favoritedVariantId);
                } else {
                    $(this).removeData('favorite-web-id');
                    $(this).removeAttr('data-favorite-web-id');
                }

                if (linkVariantId && (linkVariantId != favoritedVariantId)) { //variant favorited is different from variant of link
                    if (isSaveChangesLink) {
                        $(this).data('tooltip', "Update Favorite").show();
                    } else {
                        $(this).hide();
                    }
                } else {
                    if (isSaveChangesLink) {
                        $(this).hide();
                    } else {
                        $(this).data('tooltip', scope.unfavoriteTooltip).show();
                    }
                }
            } else {
                $(this).removeClass(scope.favoritedClass).data('tooltip', scope.favoriteTooltip);
                $(this).attr('aria-label', scope.favoriteTooltip);
            }

            $(this).addClass(scope.favoriteQueriedClass);
        });
    },

    _getFavoriteValueFromLink: function ($favoriteLink) {
        var $favLink;
        var favoriteVariantId;

        if (!$favoriteLink || $favoriteLink.length == 0) {
            return null;
        }
        $favLink = $($favoriteLink[0]);
        if ($favLink.hasClass(this.favoritedClass)) {
            favoriteVariantId = $favLink.data('favorite-web-id');
            if (favoriteVariantId) {
                return favoriteVariantId;
            } else {
                return 'true';
            }
        }
        return null;
    },

    _send: function (url, data, config) {
        config = (config = config || {});

        if (typeof data === 'string') {
            var joiner = data.indexOf("=") === -1 ? "" : "&";
            data += joiner + "_ts=" + new Date().getTime();
        } else {
            data['_ts'] = new Date().getTime();
        }

        var promise = $.ajax(url,
        {
            context: this,
            data: data,
            dataType: 'json',
            type: 'POST'
        });

        return promise;
    },

    _getAllFavoritesFromStorage: function () {
        var scope = this;

        var allFavorites = [];
        for (var i = 0; i < sessionStorage.length; i++) {
            var key = sessionStorage.key(i);
            var favorite = scope._getFavoriteFromStorage(key);
            if (favorite) {
                allFavorites.push(favorite);
            }
        }

        return allFavorites;
    },

    _getFavoriteFromStorage: function (key) {
        var favoriteSplit = key.split('-');
        if (favoriteSplit[0] !== "fav") {
            return false;
        }
        var objectType = favoriteSplit[1];
        var objectId = favoriteSplit[2];

        var value = sessionStorage[key];
        if (!value) {
            return false;
        }
        var webId = $.isNumeric(value) ? value : null;

        return { objectType: objectType, objectId: objectId, webId: webId };
    },

    _updateStorage: function (key, value) {
        if (Modernizr.sessionstorage) {
            if (value) {
                sessionStorage[key] = value;
                if (this.debug) {
                    console.log("favorite - storage - add favorite " + key + "/ value " + value);
                }
            } else {
                if (this.debug) {
                    console.log("favorite - storage - remove favorite " + key);
                }
                sessionStorage.removeItem(key);
            }
        }
    },

    _toggleFavorite: function (objectType, objectId, webId, config) {

        if (!objectId) {
            return;
        }

        if (config.scope.AccountNavigation.CustomerState == 0) {
            if (HSN.Instance().DeviceInformation.HasNativeSignin) {
                var jsonData = { "returnUrl": window.location.href };
                var command = 'hsn://HSNWebView.Signin/false/MoreInfo/' + encodeURIComponent(JSON.stringify(jsonData));
                gap.ExecCommand(command);

                return;
            }

            var modal = HSN.Instance().GetGenericConfirmModal();

            modal.SetOkCallback(function () {
                var url = '/signin?favoriteType=' + objectType + '&favoriteId=' + objectId;
                if (webId) {
                    url += '&favoriteWebId=' + webId;
                }
                window.location = url;
            });

            modal.Show('/profile/requestlogin');

            return;
        }

        var favoriteId = 'fav-' + objectType + '-' + objectId;

        if (objectType == HSN.Service.FavoriteService.OBJECT_TYPE.BRAND) {
            if (HSN.Instance().DeviceInformation.IsNativeApp) {
                gap.AddRemoveFavoriteBrand(objectId);
            }
                
            this._send("/account/favorites/add-remove-favorite-brand", {
                    brandId : objectId
                }, config)
                .done(function(data, status, xhr) {
                    var isFavorited = data.favorited;
                    var value = isFavorited ? 'true' : null;

                    if(data.success) {
                        this._updateStorage(favoriteId, value);
                    }

                    if(this.debug) {
                        console.log("favorite - ajax - " + (isFavorited ? "add" : "remove") + " brand" + objectId);
                    }

                    if(config.callback) {
                        config.callback.call((config.scope || config.callback), data.success, data.favorited);
                    }
                })
                .fail(function(data, status, xhr) {
                    if(config.callback) {
                        config.callback.call((config.scope || config.callback), 0);
                    }
                    console.log("Error favoriting brand Id " + objectId);
                });
        }
        else if (objectType === HSN.Service.FavoriteService.OBJECT_TYPE.PRODUCT) {
            if (HSN.Instance().DeviceInformation.IsNativeApp) {
                gap.AddRemoveFavoriteProduct(objectId, webId);
            }
                
            this._send("/account/favorites/add-remove-favorite-product", { productId : objectId, webId : webId }, config)
                .done(function(data, status, xhr) {
                    var isFavorited = data.favorited;
                    var value = isFavorited ? webId ? webId : 'true' : null;

                    if(data.success) {
                        this._updateStorage(favoriteId, value);
                    }

                    if(this.debug) {
                        console.log("favorite - ajax - " + (isFavorited ? "add" : "remove") + " product" + objectId + " variant " + webId);
                    }

                    if(config.callback) {
                        config.callback.call((config.scope || config.callback), data.success, data.favorited);
                    }
                })
                .fail(function(data, status, xhr) {
                    if(config.callback) {
                        config.callback.call((config.scope || config.callback), 0);
                    }
                    console.log("Error favoriting product Id " + objectId);
                });
        }
    }
};



// WEBPACK FOOTER //
// ./assets/js/HSN/Service/FavoriteService.js